module.exports = __webpack_public_path__ + "img/7R.3d46fad7.png";